export default function StatusBar({ cursor, drawing, elementsCount, activeLayer, saveState }) {
  const saveLabel = {
    saved: "✅ Saved", saving: "💾 Saving…", dirty: "⚠️ Unsaved changes", locked: "🔒 Approved — Read only",
  }[saveState] || "";
  const saveColor = { saved: "var(--c-green)", saving: "var(--c-muted)", dirty: "var(--c-amber)", locked: "var(--c-accent)" }[saveState];

  return (
    <div className="flex items-center gap-4 px-3 h-7 bg-[var(--c-surface)] border-t border-[var(--c-border)] font-mono text-[10px] text-[var(--c-muted)] shrink-0"
      data-testid="studio-statusbar">
      <span data-testid="cursor-pos">X: {cursor.x.toFixed(1)}  Y: {cursor.y.toFixed(1)}</span>
      <span>Scale: {drawing?.scale || "—"}</span>
      <span data-testid="active-layer-label">Layer: {activeLayer}</span>
      <span>Snap: Off</span>
      <span className="ml-auto truncate" data-testid="drawing-info-label">
        {drawing ? `${drawing.name}  Rev ${drawing.rev_label || drawing.revision}  |  ${drawing.status}  |  ${elementsCount} elements` : "No drawing"}
      </span>
      {saveLabel && <span style={{ color: saveColor }} data-testid="save-indicator">{saveLabel}</span>}
    </div>
  );
}
